import React, { useState } from "react";

const DropdownWithCheckbox = (props) => {
  const { selectedItems, setSelectedItems } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const items = props.options || [];

  // 🔹 Filtering based on "label" (fallback to name)
  const filteredItems = items.filter((item) =>
    (item?.label || item?.name || "")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const allFilteredSelected = filteredItems.every(item =>
    selectedItems.includes(item._id)
  );

  const handleCheckboxChange = (itemId) => {
    setSelectedItems(
      selectedItems.includes(itemId)
        ? selectedItems.filter((i) => i !== itemId)
        : [...selectedItems, itemId]
    );
  };

  const handleSelectAll = () => {
    if (allFilteredSelected) {
      // Deselect all filtered items
      setSelectedItems(selectedItems.filter(id => 
        !filteredItems.some(item => item._id === id)
      ));
    } else {
      // Select all filtered items
      const newSelections = [
        ...selectedItems,
        ...filteredItems
          .map(item => item._id)
          .filter(id => !selectedItems.includes(id))
      ];
      setSelectedItems(newSelections);
    }
  };

  return (
    <div className="dropdown">
      <button
        className="btn btn-outline-secondary dropdown-toggle w-100 text-start"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedItems?.length > 0
          ? `Selected (${selectedItems?.length})`
          : "Select Options"}
      </button>

      {isOpen && (
        <div className="dropdown-menu p-2 show w-100">
          {/* 🔎 Search box */}
          <div className="mb-2">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {/* ✅ Select All */}
          {filteredItems.length > 0 && (
            <label className="dropdown-item d-flex align-items-center">
              <input
                type="checkbox"
                className="form-check-input me-2"
                checked={allFilteredSelected}
                onChange={handleSelectAll}
              />
              Select All
            </label>
          )}

          {/* ✅ Items */}
          <div style={{ maxHeight: "200px", overflowY: "auto" }}>
            {filteredItems.length > 0 ? (
              filteredItems.map((item) => (
                <label
                  key={item._id}
                  className="dropdown-item d-flex align-items-center"
                >
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    checked={selectedItems.includes(item._id)}
                    onChange={() => handleCheckboxChange(item._id)}
                  />
                  {item.label || item.name}
                </label>
              ))
            ) : (
              <p className="text-muted text-center mb-0 small">
                No results found
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownWithCheckbox;
